import { Patient } from '../../common/patient/patient.model';

export class Conversation extends Patient {
  timestamp: string;
  unread_messages: number | null;
  last_message: string | null;
}
